export const antdTheme = {
  token: {
    colorPrimary: '#b5002a',
    colorSuccess: '#52c41a',
    colorWarning: '#faad14',
    colorError: '#ff4d4f',
    colorInfo: '#b5002a',
    borderRadius: 6,
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
  },
  components: {
    Button: {
      borderRadius: 6,
      // Primary button colors
      primaryColor: '#ffffff',
      primaryBg: '#b5002a',
      primaryBorderColor: '#b5002a',
      // Primary button hover
      primaryHoverBg: '#8f0022',
      primaryHoverBorderColor: '#8f0022',
      // Primary button active
      primaryActiveBg: '#6a0019',
      primaryActiveBorderColor: '#6a0019',
    },
    Input: {
      borderRadius: 6,
      // Border colors
      borderColor: '#d9d9d9',
      hoverBorderColor: '#e98098',
      activeBorderColor: '#b5002a',
      // Focus shadow
      activeShadow: '0 0 0 2px rgba(181, 0, 42, 0.2)',
    },
    Select: {
      borderRadius: 6,
      borderColor: '#d9d9d9',
      hoverBorderColor: '#e98098',
      activeBorderColor: '#b5002a',
      optionSelectedBg: '#e6f7ff',
      optionActiveBg: '#f5f5f5',
    },
    Menu: {
      // Active/Selected state
      itemSelectedBg: '#fff1f0',           // Light red background for selected items
      itemSelectedColor: '#b5002a',
      // Hover state
      itemHoverBg: '#fff1f0',              // Light orange background for hover
      itemHoverColor: '#000000d9',
      // Default state
      itemBg: 'transparent',
      itemColor: '#000000d9',
      // Disabled state
      itemDisabledColor: '#00000040',
    },
    Tabs: {
      // Tab colors
      itemSelectedColor: '#b5002a',
      itemHoverColor: '#e98098',
      itemActiveColor: '#b5002a',
      // Tab ink bar (active indicator)
      inkBarColor: '#b5002a',
      // Tab background
      itemBg: 'transparent',
      itemSelectedBg: 'transparent',
    },
    Switch: {
      // Toggle button colors
      colorPrimary: '#b5002a',
      colorPrimaryHover: '#e98098',
      colorPrimaryBorder: '#b5002a',
      // Switch handle
      handleBg: '#ffffff',
      handleShadow: '0 2px 4px 0 rgba(0, 35, 11, 0.2)',
    },
    Card: {
      borderRadius: 8,
    },
    Dropdown: {
      // Dropdown menu colors
      colorBgElevated: '#ffffff',
      colorBgContainer: '#ffffff',
      colorBorderSecondary: '#f0f0f0',
      // Dropdown item colors
      itemSelectedBg: '#fff1f0',           // Light red background for selected items
      itemSelectedColor: '#b5002a',
      itemHoverBg: '#fff1f0',              // Light red background for hover
      itemHoverColor: '#000000d9',
      itemColor: '#000000d9',
      itemDisabledColor: '#00000040',
      // Dropdown arrow
      colorIcon: '#b5002a',
      colorIconHover: '#8f0022',
    },
  },
}; 